exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ftue-conversation[data-v-15e28072]{height:100%;position:relative}.ftue-content[data-v-15e28072]{padding:24px;overflow:auto;position:absolute;top:70px;bottom:0;left:0;right:0}", ""]);

// exports
